import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  AdminAppealResponse,
  AdminAppealRequest,
  AdminAppealUpdateStatusRequest,
  AdminAppealUpdateStatusResponse,
  AdminAppealUpdateSumRequest,
  AdminAppelsResponse,
  getAdminAppealsApi,
  updateOrderStatusApi,
  updateOrderSumApi,
  AdminOrderAndAppeals,
  getOrderAndAppealsApi,
} from "./api";
import { State } from "@features/base/types";

export const getAdminAppeals = createAsyncThunk<
  AdminAppelsResponse,
  { data?: AdminAppealRequest }
>("adminAppeals/getAdminAppeals", async ({ data }, { rejectWithValue }) => {
  try {
    return await getAdminAppealsApi(data);
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateOrderSum = createAsyncThunk<
  string,
  { order_uuid: string; data: AdminAppealUpdateSumRequest }
>(
  "adminAppeals/updateOrderSum",
  async ({ order_uuid, data }, { rejectWithValue }) => {
    try {
      return await updateOrderSumApi(order_uuid, data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateOrderStatus = createAsyncThunk<
  AdminAppealUpdateStatusResponse,
  { appeal_id: string; data: AdminAppealUpdateStatusRequest }
>(
  "adminAppeals/updateOrderStatus",
  async ({ appeal_id, data }, { rejectWithValue }) => {
    try {
      return await updateOrderStatusApi(appeal_id, data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getOrderAndAppeals = createAsyncThunk<
  AdminOrderAndAppeals,
  { order_id: string }
>(
  "adminAppeals/getOrderAndAppeals",
  async ({ order_id }, { rejectWithValue }) => {
    try {
      return await getOrderAndAppealsApi(order_id);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export type AdminAppealsState = State<{
  appeals: AdminAppealResponse[] | null;
  loadingOrderAndAppeal: boolean;
  orderAndAppeals: AdminOrderAndAppeals | null;
  page: number,
  limit: number,
  count: number,
  total_count: number,
  isModalLoading: boolean;
  isSumModalLoading: boolean;
}>;

const initialState: AdminAppealsState = {
  appeals: null,
  orderAndAppeals: null,
  loading: false,
  loadingOrderAndAppeal: false,
  error: null,
  page: 1,
  limit: 10,
  total_count: 0,
  count: 0,
  isSumModalLoading: false,
  isModalLoading: false,
};

const adminAppealsSlice = createSlice({
  name: "adminAppeals",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdminAppeals.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdminAppeals.fulfilled, (state, action) => {
        state.loading = false;
        state.appeals = action.payload.order_appeals;
        state.page = action.payload.page;
        state.count = action.payload.count;
        state.total_count = action.payload.total_count;
      })
      .addCase(getAdminAppeals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateOrderSum.pending, (state) => {
        state.isSumModalLoading = false;
      })
      .addCase(updateOrderSum.fulfilled, (state, action) => {
        state.isSumModalLoading = false;
        console.log(action.payload);
      })
      .addCase(updateOrderSum.rejected, (state, action) => {
        state.isSumModalLoading = false;
        state.error = action.payload as string;
      })
      .addCase(updateOrderStatus.pending, (state) => {
        state.loadingOrderAndAppeal = true;
        state.error = null;
      })
      .addCase(updateOrderStatus.fulfilled, (state, action) => {
        state.loadingOrderAndAppeal = false;
        console.log(action.payload);
      })
      .addCase(updateOrderStatus.rejected, (state, action) => {
        state.loadingOrderAndAppeal = false;
        state.error = action.payload as string;
      })
      .addCase(getOrderAndAppeals.pending, (state) => {
        state.loadingOrderAndAppeal = true;
        state.error = null;
      })
      .addCase(getOrderAndAppeals.fulfilled, (state, action) => {
        state.loadingOrderAndAppeal = false;
        state.orderAndAppeals = action.payload;
      })
      .addCase(getOrderAndAppeals.rejected, (state, action) => {
        state.loadingOrderAndAppeal = false;
        state.error = action.payload as string;
      });
  },
});

export default adminAppealsSlice.reducer;
